import React from 'react'
import { i18nTranslate, getBrowserType, isExpressCheckout } from 'src/utils'
import { paymetricContainer } from 'src/models'
import './styles.scss'
import { IoIosInformationCircle as InformationIcon } from 'react-icons/io'
import {
  BsFillCheckCircleFill,
  BsFillExclamationCircleFill,
} from 'react-icons/bs'
import { observer } from 'mobx-react'
import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap'

const PaymetricCardField = observer(() => {
  const isCardTouched = paymetricContainer.paymetricCardTouched === true
  const isCardValid = paymetricContainer.paymetricCardValid === true
  const showCardSuccess = isCardTouched && isCardValid
  const showCardError = isCardTouched && !isCardValid

  return (
    <div className="paymetric-block-card" data-testid="qa-pay-card-wrapper">
      <div data-testid="qa-pay-code-wrapper">
        <div data-testid="qa-iframe_Cvv">
          <div
            id="paymetricIframeDiv"
            data-testid="qa-iframe_Card"
            className="paymetric-iframe-container"
            title="paymetric-payment-div"
          />
          {showCardSuccess && (
            <BsFillCheckCircleFill
              size="1rem"
              className="tick-icon green paymetric-card-status-icon"
            />
          )}
          {showCardError && (
            <BsFillExclamationCircleFill
              size="1rem"
              className="tick-icon red paymetric-card-status-icon"
            />
          )}
        </div>
      </div>
      {showCardError && (
        <div className="paymetric-card-error-msg">
          {i18nTranslate(
            'validation.cardNumberErrorText',
            'Please enter valid card number'
          )}
        </div>
      )}
    </div>
  )
})

const PaymetricCvvField = observer(
  ({ editUpdateModalEnabled = false } = {}) => {
    const maxLength = paymetricContainer.getPaymetricCvvMaxLength()
    const cvvText = i18nTranslate('securityCode', 'CVV')
    const showCvvSuccess =
      paymetricContainer.paymetricCvvTouched &&
      paymetricContainer.paymetricValidData?.isCvvValid === true &&
      !paymetricContainer.paymetricCvvError
    return (
      <div
        className={`paymetric-block ${
          getBrowserType()?.name?.toLowerCase() === 'edge' ? 'edge' : ''
        }`}
        data-testid="qa-pay-code-wrapper">
        {!isExpressCheckout() && (
          <label
            className="form-label security-code"
            htmlFor="paymetricCvvInput"
            data-testid="qa-cvv-label">
            {editUpdateModalEnabled
              ? i18nTranslate('payment.CVV', 'CVV/CVC *')
              : i18nTranslate('payment.securityCode', 'Security Code *')}
          </label>
        )}
        <div className="paymetric-cvv-wrapper">
          <div
            className="tokenCvv-block md-2 mr-1 mt-1"
            id="cvvID"
            data-testid="qa-iframe_Cvv">
            <input
              className={`cvvIframeHeight form-control paymetric-saved-cvv-input ${
                paymetricContainer.paymetricCvvError
                  ? 'paymetric-cvv-input-error is-invalid'
                  : ''
              }`}
              data-testid="qa-pay-code"
              id="paymetricCvvInput"
              type="password"
              placeholder={cvvText}
              aria-label={cvvText}
              inputMode="numeric"
              pattern="[0-9]*"
              autoComplete="new-password"
              maxLength={maxLength}
              value={paymetricContainer.paymetricCvv}
              onChange={paymetricContainer.onPaymetricCvvChange}
              onBlur={() => {
                paymetricContainer.validatePaymetricCvvOnBlur()
              }}
            />
            <div
              className={`cardCvvtoken ${
                paymetricContainer.paymetricCvvError ? 'show' : ''
              }`}>
              {i18nTranslate(
                'validation.cardCvvErrorText',
                'Please enter valid security code'
              )}
            </div>
            {showCvvSuccess && (
              <BsFillCheckCircleFill
                size="1rem"
                className="tick-icon green paymetric-cvv-status-icon"
              />
            )}
            {paymetricContainer.paymetricCvvError && (
              <BsFillExclamationCircleFill
                size="1rem"
                className="tick-icon red paymetric-cvv-status-icon"
              />
            )}
          </div>
          <OverlayTrigger
            trigger={'click'}
            placement="top"
            rootClose={true}
            overlay={
              <Tooltip
                id="cvv-tooltip"
                className="new-cvv-tooltip"
                data-testid="qa-cvv-info-tooltip">
                {i18nTranslate(
                  'payment.cvvInfo',
                  'To proceed with your transaction, enter your Card Verification Value found at the back of your card.'
                )}
              </Tooltip>
            }>
            <Button
              className="new-cvv-tooltip-info-button"
              data-testid="qa-cvv-info-button">
              <InformationIcon
                aria-label="Information tool"
                size="1.5rem"
                id="info-black-button-paymetric-payment"
                className="infotool"
              />
            </Button>
          </OverlayTrigger>
        </div>
      </div>
    )
  }
)

const getIframeText = (editUpdateModalEnabled = false) => {
  return {
    cardNumberLabel: editUpdateModalEnabled
      ? i18nTranslate(
          'paymetric.reEnterCardNumber',
          i18nTranslate('payment.reEnterCardNumber', 'Re-Enter Card Number *')
        )
      : i18nTranslate(
          'paymetric.cardNumberLabel',
          i18nTranslate('payment.cardNumber', 'Card Number *')
        ),
    cardNumberPlaceholder: i18nTranslate(
      'paymetric.cardNumberPlaceholder',
      i18nTranslate('payment.tokenexCardNumber', 'Card Number')
    ),
    cardNumberError: i18nTranslate(
      'validation.cardNumberErrorText',
      'Please enter valid card number'
    ),
    cvvLabel: i18nTranslate('payment.cardCVV', 'Security Code *'),
    cvvPlaceholder: i18nTranslate('securityCode', 'CVV'),
    cvvError: i18nTranslate(
      'validation.cardCvvErrorText',
      'Please enter valid security code'
    ),
  }
}

const paymetricIframe = {
  isFromCreditCard: () => <PaymetricCardField />,
  isFromCVV: editUpdateModalEnabled => (
    <PaymetricCvvField editUpdateModalEnabled={editUpdateModalEnabled} />
  ),
  isDisplayNoneCVV: () => <></>,
  getIframeText,
}

export default paymetricIframe
export { paymetricIframe }
